<template>
    <div class="p-grid">
        <div class="p-col-12">             
            <Toolbar class="p-mb-4">
                <template slot="left">						
                    <Button type="button" icon="pi pi-check" label="Selecionar Permissão" class="p-mr-2"
                     :disabled="menuSelecionado == null" @click="exibirModalSelecionar"/>
                    <Button type="button" icon="pi pi-check" label="Selecionar Usuário" class="p-mr-2" 
                        @click="exibirSelecionarUusarioDestino(true)"/>
                    <Button type="button" icon="pi pi-arrow-circle-up" label="Publicar" class="p-mr-2" 
                     v-if="exibirBotaoPublicar" @click="exibirDialogConfirmar=true"/>
                     <Button type="button" icon="pi pi-refresh" title="Atualizar lista do menu" class="p-mr-2" @click="listar"/>								
                </template>					
            </Toolbar>            
            <div class="p-fluid p-formgrid p-grid">
                <div class="p-field p-col-12 p-md-4">                          
                    <ScrollPanel style="width: 100%; height: 500px">
                        <Tree :value="itensMenu" :filter="true" filterMode="lenient" selectionMode="single" :selectionKeys.sync="idMenuSelecionado"
                            @node-select="selecionarPermissoes">
                            <template #default="slotProps">
                                {{slotProps.node.label}}
                            </template>
                            <template #novo="slotProps">
                                <b>{{slotProps.node.label}}</b>
                            </template>
                            <template #desativado="slotProps">
                                <span style="color:#C13928"> {{slotProps.node.label}}</span>
                            </template>
                        </Tree>
                    </ScrollPanel>                        
                </div>
                <div class="p-field p-col-12 p-md-8">
                    <TabView>
                        <TabPanel header="Publicar">
                            <div class="p-grid p-mb-2">
                                <div class="p-col">
                                    <Button icon="pi pi-trash" title="Excluir" :disabled="permissaoPublicarSelecionada == null"
                                        class="p-button-danger" @click="excluirPermissaoPulibcar"/>
                                </div>                           
                            </div>
                            <div class="p-fluid p-formgrid p-grid">
                                <div class="p-field p-col">                                
                                    <Listbox v-model="permissaoPublicarSelecionada" :options="permissoesPublicar" optionLabel="descricao" listStyle="height:180px" />                                
                                </div>
                            </div>                            
                        </TabPanel>
                        <TabPanel header="Usuários Destino">
                            <div class="p-grid p-mb-2">
                                <div class="p-col">
                                    <Button icon="pi pi-trash" title="Excluir" :disabled="usuDestinoSelecionado == null" 
                                       class="p-button-danger" @click="excluirUsuarioDestino"/>
                                </div>                           
                            </div>
                            <div class="p-fluid p-formgrid p-grid">
                                <div class="p-field p-col">                                
                                    <Listbox v-model="usuDestinoSelecionado" :options="usuariosDestino" optionLabel="descricao" listStyle="height:180px" />                                
                                </div>
                            </div>
                        </TabPanel>
                    </TabView>                                          
                </div>                
            </div>                             
        </div>      

        <Dialog :visible.sync="exibirDialogConfirmar" header="Confirmar" :modal="true" :style="{width: '450px'}">
            <p>Publicar permissões?</p> 
             <div class="p-fluid p-formgrid p-grid">
                 
                <div class="p-field p-col-12 p-md-12">
                    <TabView>
                            <TabPanel header="Permissões">
                                <Listbox :options="permissoesPublicar" optionLabel="descricao" listStyle="height:180px" /> 
                            </TabPanel>
                            <TabPanel header="Usuários">
                                <Listbox :options="usuariosDestino" optionLabel="descricao" listStyle="height:180px" v-if="usuariosDestino.length > 0" /> 
                                <p v-if="usuariosDestino.length == 0" >[[ TODOS ]]</p>
                            </TabPanel>
                    </TabView>  
                </div>
            </div>
            <template #footer>
                <Button label="Cancelar" icon="pi pi-times" class="p-button-secondary" @click="exibirDialogConfirmar=false"/>
                <Button label="Publicar" icon="pi pi-check" @click="publicar" />
            </template>
        </Dialog>

        <Dialog :visible.sync="exibirDialogSelecionar" header="Selecionar Permissões" :modal="true" class="p-fluid" 
            :style="{width: '500px'}" @hide="exibirDialogSelecionar=false"> 
            <div class="p-fluid p-formgrid p-grid">                
                <div class="p-field p-col">
                    <div v-for="permissao of permissoesSelecionar" :key="permissao.id">
                        <div class="p-field-checkbox">
                            <Checkbox :id="permissao.id" v-model="permissao.selecionado" :binary="true"/>
                            <label>{{permissao.descricao}}</label>
                        </div>
                    </div>                               
                </div>
            </div>
            <template #footer>
                <Button label="Cancelar" icon="pi pi-times" class="p-button-secondary" @click="exibirDialogSelecionar=false"/>
                <Button label="OK" icon="pi pi-check" @click="moverParaPublicar"/>
            </template>
        </Dialog>

        <Dialog :visible.sync="exibirDialogUsuarioDestino" header="Usuários" :modal="true" class="p-fluid" 
            :style="{width: '700px'}" @hide="exibirSelecionarUusarioDestino(false)"> 
            <div class="p-fluid p-formgrid p-grid"> 
                <div class="p-field p-col-12 p-md-8">
                    <label>Código Cliente</label>
                    <InputText v-model="codigoCliente" autocomplete="off" v-on:keyup.enter="buscarUsuario"/>                         
                </div>
                <div class="p-field p-col-auto">
                    <Button label="Buscar" class="p-ml-2" style="margin-top: 26px;" icon="pi pi-search" @click="buscarUsuario"/>
                </div>               
            </div>
            <div class="p-fluid p-formgrid p-grid">
                <div class="p-field p-col-12 p-md-8">
                    <Listbox v-model="usuDestinoSelecionado" :options="usuariosDestino" optionLabel="descricao" listStyle="max-height:250px"/>
                </div>                    
                <div class="p-field p-col-1">
                    <Button class="p-button-danger" icon="pi pi-times" title="Excluir" v-if="usuDestinoSelecionado" @click="excluirUsuarioDestino"/>  
                </div>                    
            </div>  
            <template #footer>
                <Button label="Cancelar" icon="pi pi-times" class="p-button-secondary" @click="excluirTodosUsuariosDestino"/>
                <Button label="OK" icon="pi pi-check" @click="exibirSelecionarUusarioDestino(false)"/>
            </template>
        </Dialog>

    </div>  
</template>

<script>
import MenuService from '@/service/MenuService';
import UsuarioService from '@/service/UsuarioService';
import { exibirMensagem, clonar } from '@/global';
import { mapGetters } from 'vuex';

export default {
    menuService: null,
    usuarioService: null,
    data() {
        return {   
            exibirDialogUsuarioDestino: false,
            exibirBotaoPublicar: false,       
            exibirDialogConfirmar: false,
            exibirDialogMenu: false,    
            exibirDialogSelecionar: false,
            idMenuSelecionado: null,               
            itemPublicar: false,          
            menuSelecionado: null,        
            itensMenu:[],           
            usuariosDestino: [], 
            perfisDestino: [],
            usuDestinoSelecionado: null, 
            permissaoPublicarSelecionada: null,
            permissoesPublicar: [],                  
            permissoesSelecionar: [],
            codigoCliente: '',
        }
    },
    methods: {
        ...mapGetters('sessao', ['getDadosRequisicao']),       
        publicar() {  
            let itensMenuPublicar = new Map();
            this.permissoesPublicar.forEach(perm => {                
                if(!perm.menuPublicar.publicado) {
                    if(itensMenuPublicar.get(perm.menuPublicar.id) == null) {
                        itensMenuPublicar.set(perm.menuPublicar.id, perm.menuPublicar);
                    }
                }
            });           
            let requisicao = {           
                itensMenuPublicar: Array.from(itensMenuPublicar.values()),     
                perfisDestino: clonar(this.perfisDestino),
                permissoes: clonar(this.permissoesPublicar),
                usuarioRequisicao: {...this.getDadosRequisicao()}
            }               
            this.menuService.pulicar(requisicao)
                .then(resp => {		
                    exibirMensagem(this, resp); 
                    this.listar();
                    this.reset();
                })
                .catch(erro => {exibirMensagem(this, erro)}); 
        },               
        listar() {
            this.reset();     
            let requisicao = {
                usuarioRequisicao: {...this.getDadosRequisicao()}
            }	
            this.menuService.listar(requisicao)
				.then(resp => {			
					this.itensMenu = this.converterMenu(resp.data);	
                })
                .catch(erro => {exibirMensagem(this, erro)});            
        } ,
        converterMenu(menu) {
            let itens = [];
            menu.forEach(me => {
                me.permissoes.forEach(perm => {
                    perm['selecionado'] = false;   
                    let tipo = '';
                    if(!perm.publicado) {
                        tipo = ' (Novo)';
                    }
                    if(!perm.ativo) {
                        tipo = ' (Desativado)';
                    }  
                    perm['descricao'] = perm.codigo+' - '+perm.nome+' - '+perm.nomeOperacao+tipo;
                });
                let type = 'default';
                if(!me.publicado) {
                    type = 'novo';
                }
                if(!me.ativo) {
                    type = 'desativado';
                }        
                let objMenu = {
                    key: me.id,
                    label: me.nome,
                    data: me.nome,
                    icon: (me.menuFilhos.length == 0 ? 'pi pi-fw pi-tags' : ''),
                    type: type,
                    children: (me.menuFilhos.length > 0 ? this.converterMenu(me.menuFilhos) : []),
                    original: me,
                }
                itens.push(objMenu);
            });
            return itens;
        },  
        selecionarPermissoes(menu) {
            this.menuSelecionado = menu;
            this.permissoesSelecionar = clonar(menu.original.permissoes);            
        },              
        exibirModalSelecionar() {
            let encontrou = false;
            this.permissoesSelecionar.forEach(perm => {
                let tipo = '';
                if(!perm.publicado) {
                    tipo = ' (Novo)';
                }
                if(!perm.ativo) {
                    tipo = ' (Desativado)';
                }  
                perm['descricao'] = perm.codigo+' - '+perm.nome+' - '+perm.nomeOperacao+tipo;
                encontrou = false;              
                this.permissoesPublicar.forEach(permPublicar => {
                    if(perm.id == permPublicar.id) {
                        encontrou = true;
                    }
                });                
                perm.selecionado = encontrou;
            });
            this.exibirDialogSelecionar = true;
        },     
        moverParaPublicar() {
            this.permissoesPublicar = [];
            this.permissoesSelecionar.forEach(perm => {
                if(perm.selecionado) {
                    let pPub = {...perm}; 
                    let mn = clonar(this.menuSelecionado.original);
                    mn.permissoes = [];
                    pPub['menuPublicar'] = mn;
                    this.permissoesPublicar.push(pPub);
                }
            });            
            this.exibirDialogSelecionar = false;    
            this.testeBotaoPublicar();        
        },         
        excluirPermissaoPulibcar() {            
            let indexExcluir = 0;
            this.permissoesPublicar.forEach((permPublicar, i) => {
                if(this.permissaoPublicarSelecionada.id == permPublicar.id) {
                    indexExcluir = i;
                }
            });           
            this.permissoesPublicar.splice(indexExcluir, 1);  
            this.testeBotaoPublicar();                
        },    
        buscarUsuario() {
            if(this.codigoCliente != '' && !isNaN(this.codigoCliente)) {
                let requisicao = {
                    codigoCliente: this.codigoCliente,
                    usuarioRequisicao: {...this.getDadosRequisicao()}
                }
                this.usuarioService.buscarDonoConta(requisicao)
                    .then(resp => {			                      
                        let usuario = resp.data.usuario;
                        usuario['descricao'] = usuario.nome + ' - '+usuario.email;                     
                        let encontrou = false;
                        this.usuariosDestino.forEach(usu => {
                            if(usu.id == usuario.id) {
                                encontrou = true;
                            }
                        });
                        if(!encontrou) {
                            this.usuariosDestino.push(usuario);
                            this.perfisDestino.push(resp.data.perfil);
                        }
                    })
                    .catch(erro => {exibirMensagem(this, erro)});                 
            }
        }, 
        excluirTodosUsuariosDestino() {
            this.usuariosDestino = [];
            this.perfisDestino = [];
            this.usuDestinoSelecionado = null;
            this.exibirDialogUsuarioDestino = false;
        },
        excluirUsuarioDestino() {
            let index;
            this.usuariosDestino.forEach((usu, i) => {
                if(usu.id == this.usuDestinoSelecionado.id) {
                    index = i;
                }
            });               
            this.usuDestinoSelecionado = null;
            this.usuariosDestino.splice(index, 1);  
            this.perfisDestino.splice(index, 1);   
        },  
        exibirSelecionarUusarioDestino(exibir) {
            this.usuDestinoSelecionado = null;
            this.exibirDialogUsuarioDestino = exibir;
        },
        testeBotaoPublicar() {
            this.exibirBotaoPublicar = false;
            if (this.permissoesPublicar.length > 0) {
                this.exibirBotaoPublicar = true;
            }
        }, 
        reset() {
            this.usuariosDestino = [], 
            this.perfisDestino = [];
            this.permissaoUsuarioSelecionada = null,     
            this.permissaoPublicarSelecionada = null,
            this.permissoesPublicar = [],                  
            this.permissoesSelecionar = [],
            this.menuSelecionado = null;
            this.exibirBotaoPublicar = false;   
            this.exibirDialogConfirmar = false;   
        } 
    },
    created() {
        this.menuService = new MenuService();
        this.usuarioService = new UsuarioService();
    },
    mounted() {
        this.listar();
    }
}
</script>

<style>
</style>